import { render, staticRenderFns } from "./ProductBlock.vue?vue&type=template&id=47cb501a&scoped=true&"
import script from "./ProductBlock.vue?vue&type=script&lang=js&"
export * from "./ProductBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProductBlock.vue?vue&type=style&index=0&id=47cb501a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cb501a",
  null
  
)

export default component.exports